export const sequences2026 = [
  ['are', 'race', 'cared', 'sacred'],
  ['ear', 'real', 'early', 'really'],
  ['ate', 'seat', 'stake', 'streak'],
  ['tea', 'tale', 'steal', 'latest'],
  ['eat', 'seat', 'sweat', 'sweaty'],
  ['are', 'rate', 'terra', 'arrest'],
  ['ear', 'care', 'carve', 'carved'],
  ['set', 'site', 'heist', 'ethics'],
  ['air', 'raid', 'aired', 'raised'],
  ['eat', 'rate', 'heart', 'rather'],
  ['are', 'hear', 'share', 'search'],
  ['ear', 'year', 'repay', 'player'],
  ['let', 'late', 'metal', 'mental'],
  ['tie', 'site', 'spite', 'priest'],
  ['tea', 'fate', 'feast', 'safest'],
  ['are', 'care', 'cater', 'cartel'],
  ['ear', 'earl', 'alter', 'travel'],
  ['ace', 'care', 'crave', 'carver'],
  ['ran', 'warn', 'drawn', 'warned'],
  ['tea', 'east', 'feast', 'safety'],
  ['are', 'bear', 'brake', 'barker'],
  ['ear', 'rate', 'extra', 'baxter'],
  ['ate', 'team', 'matey', 'steamy'],
  ['end', 'tend', 'noted', 'donate'],
  ['pal', 'slap', 'lapse', 'please'],
  ['are', 'gear', 'agree', 'agreed'],
  ['ear', 'earl', 'later', 'learnt'],
  ['ten', 'note', 'noted', 'donate'],
  ['bar', 'bear', 'rehab', 'breath'],
  ['ate', 'seat', 'feast', 'faster'],
  ['are', 'dear', 'cedar', 'sacred'],
  ['ear', 'dare', 'dream', 'dreamt'],
  ['ten', 'tone', 'stone', 'stoned'],
  ['and', 'darn', 'grand', 'danger'],
  ['nap', 'pain', 'panic', 'pacing'],
  ['are', 'rate', 'mater', 'market'],
  ['ear', 'tear', 'mater', 'matter'],
  ['art', 'star', 'start', 'artist'],
  ['she', 'shoe', 'chose', 'choose'],
  ['eat', 'east', 'stale', 'slater'],
  ['are', 'tear', 'trade', 'dreamt'],
  ['ear', 'dare', 'dread', 'raided'],
  ['tea', 'east', 'caste', 'aspect'],
  ['can', 'clan', 'clang', 'glance'],
  ['car', 'cart', 'actor', 'factor'],
  ['are', 'dear', 'dread', 'traded'],
  ['ear', 'rate', 'trade', 'hatred'],
  ['ate', 'take', 'steak', 'streak'],
  ['ice', 'rice', 'cider', 'credit'],
  ['bet', 'beat', 'bathe', 'breath'],
  ['are', 'care', 'raced', 'traced'],
  ['ear', 'dear', 'adore', 'ordeal'],
  ['art', 'star', 'stark', 'streak'],
  ['wet', 'west', 'sweat', 'sweaty'],
  ['set', 'seat', 'sweat', 'sweaty'],
  ['are', 'real', 'laser', 'serial'],
  ['ear', 'race', 'cared', 'sacred'],
  ['tea', 'seat', 'steal', 'castle'],
  ['lee', 'else', 'steel', 'settle'],
  ['doc', 'code', 'coded', 'docked'],
  ['are', 'earn', 'yearn', 'nearby'],
  ['ear', 'rage', 'grave', 'garvey'],
  ['ate', 'late', 'stale', 'salute'],
  ['ten', 'note', 'monte', 'moment'],
  ['nap', 'pain', 'paint', 'taping'],
  ['are', 'year', 'repay', 'player'],
  ['ear', 'bear', 'beard', 'barred'],
  ['ate', 'seat', 'asset', 'safest'],
  ['air', 'raid', 'drain', 'rained'],
  ['arm', 'harm', 'harem', 'hammer'],
  ['are', 'real', 'alter', 'learnt'],
  ['ear', 'real', 'ariel', 'aerial'],
  ['red', 'dare', 'drake', 'marked'],
  ['ten', 'nest', 'scent', 'insect'],
  ['ace', 'care', 'recap', 'preach'],
  ['air', 'pair', 'rapid', 'diaper'],
  ['aid', 'raid', 'rapid', 'paired'],
  ['red', 'ride', 'ridge', 'rigged'],
  ['tea', 'date', 'acted', 'traced'],
  ['row', 'grow', 'wrong', 'rowing'],
  ['ace', 'pace', 'cheap', 'preach'],
  ['rob', 'born', 'boner', 'broken'],
  ['not', 'torn', 'thorn', 'throne'],
  ['fit', 'fist', 'shift', 'fetish'],
  ['the', 'thee', 'teeth', 'tether'],
  ['ace', 'race', 'cared', 'scared'],
  ['ate', 'east', 'steak', 'basket'],
  ['she', 'shoe', 'whose', 'showed'],
  ['our', 'tour', 'outer', 'troupe'],
  ['nut', 'unit', 'input', 'turnip'],
  ['tea', 'tale', 'slate', 'stable'],
  ['ate', 'tear', 'earth', 'threat'],
  ['not', 'into', 'point', 'option'],
  ['one', 'open', 'phone', 'phoned'],
  ['all', 'call', 'local', 'collar'],
  ['bar', 'bear', 'bread', 'badger'],
  ['ate', 'east', 'tease', 'senate'],
  ['sea', 'sale', 'leash', 'sheila'],
  ['man', 'name', 'named', 'maiden'],
  ['see', 'seed', 'speed', 'speedy'],
  ['day', 'yard', 'ready', 'prayed'],
  ['ate', 'tale', 'steal', 'latest'],
  ['sea', 'east', 'steam', 'steamy'],
  ['tea', 'tear', 'treat', 'target'],
  ['ten', 'neat', 'agent', 'eating'],
  ['her', 'here', 'sheer', 'sphere'],
  ['lad', 'glad', 'gland', 'dangle'],
  ['sea', 'seat', 'waste', 'wasted'],
  ['car', 'race', 'raced', 'cradle'],
  ['all', 'ally', 'alley', 'really'],
  ['owe', 'wore', 'owner', 'wonder'],
  ['eat', 'late', 'fetal', 'falter'],
  ['red', 'read', 'bread', 'barbed'],
  ['car', 'care', 'crane', 'cancer'],
  ['not', 'torn', 'snort', 'strong'],
  ['aye', 'easy', 'yeast', 'stayed'],
  ['sin', 'sing', 'sling', 'losing'],
  ['lie', 'line', 'linen', 'linden'],
  ['ate', 'team', 'meant', 'mental'],
  ['fed', 'fled', 'filed', 'filled'],
  ['art', 'rate', 'trade', 'hatred'],
  ['day', 'yard', 'randy', 'brandy'],
  ['eat', 'take', 'steak', 'streak'],
  ['air', 'liar', 'ariel', 'serial'],
  ['led', 'deal', 'laced', 'called'],
  ['ate', 'neat', 'taken', 'tanker'],
  ['lad', 'laid', 'ideal', 'nailed'],
  ['pat', 'past', 'splat', 'postal'],
  ['eat', 'seat', 'paste', 'aspect'],
  ['gee', 'edge', 'greed', 'agreed'],
  ['tea', 'rate', 'terra', 'arrest'],
  ['ace', 'each', 'peach', 'preach'],
  ['net', 'nest', 'scent', 'insect'],
  ['let', 'late', 'alter', 'learnt'],
  ['pal', 'plan', 'panel', 'alpine'],
  ['tap', 'part', 'strap', 'pastor'],
  ['ate', 'late', 'least', 'castle'],
  ['bar', 'bare', 'beard', 'barged'],
  ['set', 'seat', 'steam', 'master'],
  ['the', 'heat', 'heath', 'health'],
  ['sat', 'task', 'skate', 'streak'],
  ['ate', 'seat', 'stage', 'staged'],
  ['she', 'shoe', 'shove', 'shovel'],
  ['set', 'seat', 'stale', 'lasted'],
  ['met', 'term', 'merit', 'mister'],
  ['tea', 'rate', 'later', 'travel'],
  ['sat', 'past', 'splat', 'staple'],
  ['mad', 'made', 'armed', 'marked'],
  ['had', 'head', 'heard', 'harder'],
  ['eat', 'rate', 'cater', 'racket'],
  ['rid', 'raid', 'aired', 'admire'],
  ['led', 'held', 'holed', 'behold'],
  ['don', 'done', 'noted', 'donate'],
  ['tea', 'late', 'least', 'castle'],
  ['net', 'tune', 'untie', 'minute'],
  ['cat', 'cast', 'caste', 'castle'],
  ['car', 'race', 'crave', 'carved'],
  ['ten', 'note', 'often', 'soften'],
  ['eat', 'date', 'cadet', 'coated'],
  ['bar', 'bare', 'barge', 'banger'],
  ['red', 'dare', 'cared', 'dancer'],
  ['ace', 'case', 'sauce', 'accuse'],
  ['tea', 'rate', 'treat', 'matter'],
  ['sue', 'sure', 'nurse', 'ensure'],
  ['use', 'sure', 'usher', 'rushed'],
  ['eat', 'date', 'fated', 'defeat'],
  ['ole', 'lose', 'loose', 'loosen'],
  ['led', 'dale', 'laden', 'nailed'],
  ['tea', 'seat', 'state', 'estate'],
  ['art', 'rate', 'react', 'cartel'],
  ['eat', 'seat', 'waste', 'wasted'],
  ['age', 'gate', 'great', 'target'],
  ['led', 'deal', 'plead', 'placed'],
  ['son', 'nose', 'noise', 'senior'],
  ['row', 'word', 'sword', 'drowsy'],
  ['eat', 'neat', 'atone', 'donate'],
  ['met', 'meet', 'metre', 'temper'],
  ['tea', 'fate', 'after', 'father'],
  ['red', 'rude', 'lured', 'hurdle'],
  ['sea', 'ease', 'cease', 'escape'],
  ['one', 'nope', 'prone', 'proven'],
  ['old', 'bold', 'blond', 'blonde'],
  ['tea', 'tear', 'great', 'garret'],
  ['red', 'deer', 'freed', 'feared'],
  ['bro', 'bore', 'borne', 'reborn'],
  ['one', 'oven', 'envoy', 'convey'],
  ['ate', 'tear', 'crate', 'racket'],
  ['she', 'shoe', 'those', 'honest'],
  ['ask', 'task', 'stake', 'streak'],
  ['red', 'dare', 'aired', 'rained'],
  ['sat', 'last', 'slate', 'salute'],
  ['and', 'darn', 'drain', 'daring'],
  ['due', 'rude', 'cured', 'cursed'],
  ['end', 'done', 'owned', 'wonder'],
  ['ace', 'race', 'react', 'create'],
  ['net', 'neat', 'meant', 'mental'],
  ['ole', 'hole', 'holed', 'behold'],
  ['nap', 'plan', 'plain', 'spinal'],
  ['hot', 'shot', 'short', 'shorty'],
  ['ray', 'yard', 'ready', 'dearly'],
  ['age', 'rage', 'grade', 'agreed'],
  ['use', 'sure', 'nurse', 'ensure'],
  ['rid', 'raid', 'braid', 'bridal'],
  ['ten', 'tone', 'noted', 'rodent'],
  ['pen', 'open', 'prone', 'person'],
  ['red', 'dare', 'bread', 'barred'],
  ['cat', 'cart', 'craft', 'crafty'],
  ['ace', 'came', 'cream', 'camera'],
  ['ain', 'main', 'manic', 'cinema'],
  ['lad', 'land', 'gland', 'dangle'],
  ['eat', 'tear', 'tread', 'dreamt'],
  ['far', 'fair', 'fairy', 'fairly'],
  ['car', 'scar', 'scram', 'racism'],
  ['sea', 'same', 'smear', 'scream'],
  ['rid', 'raid', 'laird', 'lizard'],
  ['eat', 'neat', 'agent', 'magnet'],
  ['far', 'fear', 'freak', 'freaky'],
  ['car', 'carl', 'carol', 'collar'],
  ['any', 'yang', 'angry', 'granny'],
  ['hit', 'this', 'shirt', 'thirst'],
  ['set', 'seat', 'slate', 'stella'],
  ['men', 'amen', 'meant', 'inmate'],
  ['rat', 'trap', 'party', 'pastry'],
  ['bet', 'beat', 'beast', 'basket'],
  ['one', 'note', 'often', 'soften'],
  ['sat', 'east', 'taste', 'estate'],
  ['rid', 'ride', 'ridge', 'rigged'],
  ['set', 'seat', 'waste', 'wasted'],
  ['nor', 'born', 'borne', 'bronze'],
  ['use', 'sure', 'purse', 'pursue'],
  ['rat', 'tear', 'terra', 'artery'],
  ['ask', 'sake', 'shake', 'shaken'],
  ['pro', 'port', 'troop', 'proton'],
  ['yep', 'prey', 'repay', 'prayed'],
  ['out', 'tour', 'turbo', 'burton'],
  ['nut', 'aunt', 'haunt', 'naught'],
  ['lad', 'lead', 'plead', 'played'],
  ['set', 'seat', 'state', 'latest'],
  ['one', 'nose', 'stone', 'honest'],
  ['per', 'rope', 'opera', 'parole'],
  ['don', 'fond', 'found', 'unfold'],
  ['aid', 'laid', 'tidal', 'tailed'],
  ['set', 'seat', 'stake', 'streak'],
  ['sit', 'spit', 'split', 'spoilt'],
  ['pen', 'nope', 'prone', 'proven'],
  ['owe', 'wore', 'swore', 'slower'],
  ['rat', 'tear', 'crate', 'racket'],
  ['ace', 'cave', 'caved', 'advice'],
  ['ten', 'rent', 'enter', 'entire'],
  ['ole', 'role', 'loner', 'longer'],
  ['eat', 'date', 'taped', 'update'],
  ['pet', 'step', 'slept', 'staple'],
  ['sea', 'seat', 'haste', 'chaste'],
  ['art', 'trap', 'tramp', 'tamper'],
  ['sat', 'star', 'stray', 'astray'],
  ['eat', 'team', 'mater', 'matter'],
  ['net', 'note', 'tenor', 'rotten'],
  ['ale', 'lame', 'camel', 'calmed'],
  ['out', 'tour', 'tumor', 'tumour'],
  ['aid', 'said', 'aside', 'raised'],
  ['eat', 'rate', 'terra', 'arrest'],
  ['gay', 'gray', 'angry', 'granny'],
  ['ale', 'meal', 'ample', 'sample'],
  ['ran', 'darn', 'grand', 'danger'],
  ['bar', 'bear', 'baker', 'bakery'],
  ['rid', 'ride', 'tried', 'credit'],
  ['bro', 'born', 'robin', 'boring'],
  ['rat', 'rate', 'tread', 'dreamt'],
  ['lip', 'slip', 'split', 'pistol'],
  ['lie', 'file', 'field', 'filled'],
  ['ale', 'male', 'realm', 'palmer'],
  ['per', 'pure', 'upper', 'purple'],
  ['ran', 'darn', 'grand', 'danger'],
  ['ole', 'mole', 'lemon', 'solemn'],
  ['bag', 'grab', 'barge', 'beggar'],
  ['sea', 'sale', 'lapse', 'asleep'],
  ['rat', 'rate', 'terra', 'arrest'],
  ['lie', 'lied', 'wield', 'wilder'],
  ['ten', 'nest', 'stern', 'unrest'],
  ['car', 'race', 'carve', 'carver'],
  ['pro', 'rope', 'pedro', 'poured'],
  ['sat', 'cast', 'coast', 'mascot'],
  ['ace', 'race', 'crane', 'dancer'],
  ['con', 'once', 'ocean', 'beacon'],
  ['sea', 'east', 'tease', 'senate'],
  ['rip', 'trip', 'print', 'sprint'],
  ['sat', 'stay', 'stray', 'pastry'],
  ['ate', 'date', 'taped', 'update'],
  ['and', 'dawn', 'drawn', 'warned'],
  ['sea', 'seat', 'stake', 'basket'],
  ['set', 'east', 'caste', 'stance'],
  ['pro', 'port', 'sport', 'pastor'],
  ['not', 'note', 'often', 'soften'],
  ['dry', 'yard', 'randy', 'brandy'],
  ['sea', 'ease', 'tease', 'estate'],
  ['aid', 'maid', 'aimed', 'admire'],
  ['ten', 'sent', 'stein', 'listen'],
  ['lad', 'load', 'aloud', 'unload'],
  ['ace', 'pace', 'recap', 'carpet'],
  ['pit', 'spit', 'spite', 'septic'],
  ['her', 'hire', 'hired', 'hinder'],
  ['sit', 'this', 'heist', 'ethics'],
  ['red', 'read', 'cared', 'sacred'],
  ['cat', 'chat', 'chart', 'starch'],
  ['art', 'tear', 'crate', 'racket'],
  ['sea', 'seat', 'beast', 'stable'],
  ['ran', 'near', 'raven', 'tavern'],
  ['ole', 'mole', 'model', 'melody'],
  ['sat', 'last', 'atlas', 'stalag'],
  ['red', 'read', 'raced', 'traced'],
  ['sea', 'seat', 'caste', 'stance'],
  ['ben', 'bone', 'boner', 'broken'],
  ['cat', 'cast', 'costa', 'mascot'],
  ['lay', 'clay', 'lacey', 'legacy'],
  ['not', 'tone', 'monte', 'mentor'],
  ['all', 'fall', 'fella', 'fallen'],
  ['sat', 'seat', 'least', 'latest'],
  ['the', 'heat', 'heart', 'father'],
  ['hut', 'thou', 'touch', 'touchy'],
  ['pan', 'pain', 'panic', 'pacing'],
  ['own', 'down', 'owned', 'wonder'],
  ['sat', 'stay', 'salty', 'vastly'],
  ['bar', 'bare', 'bread', 'barred'],
  ['met', 'term', 'timer', 'permit'],
  ['the', 'then', 'thine', 'ethnic'],
  ['red', 'ride', 'cried', 'priced'],
  ['bid', 'bird', 'bride', 'bridge'],
  ['bar', 'barn', 'baron', 'carbon'],
  ['bed', 'debt', 'debut', 'busted'],
  ['due', 'rude', 'crude', 'reduce'],
  ['men', 'omen', 'lemon', 'solemn'],
  ['mad', 'made', 'named', 'demand'],
  ['ace', 'pace', 'peach', 'chapel'],
  ['tag', 'gate', 'agent', 'eating'],
  ['act', 'chat', 'cheat', 'chalet'],
  ['red', 'read', 'rated', 'depart'],
  ['age', 'rage', 'glare', 'larger'],
  ['sea', 'seat', 'least', 'castle'],
  ['sat', 'fast', 'feast', 'faster'],
  ['old', 'loud', 'cloud', 'cloudy'],
  ['pit', 'spit', 'spilt', 'spoilt'],
  ['tip', 'spit', 'spite', 'septic'],
  ['sea', 'base', 'abuse', 'basque'],
  ['sat', 'last', 'blast', 'stable'],
  ['ham', 'ahem', 'harem', 'harmed'],
  ['pet', 'type', 'petty', 'pretty'],
  ['car', 'card', 'cared', 'scared'],
  ['nor', 'worn', 'rowan', 'narrow'],
  ['fat', 'fact', 'craft', 'factor'],
  ['ain', 'gain', 'aging', 'raging'],
  ['rat', 'rate', 'cater', 'racket'],
  ['red', 'ride', 'diver', 'driven'],
  ['lit', 'list', 'split', 'pistol'],
  ['led', 'lead', 'plead', 'played'],
  ['ole', 'lose', 'loser', 'closer'],
  ['let', 'late', 'slate', 'stella'],
  ['hat', 'heat', 'cheat', 'chalet'],
  ['old', 'gold', 'lodge', 'golden'],
  ['sea', 'seat', 'skate', 'casket'],
  ['han', 'than', 'chant', 'snatch'],
  ['eve', 'ever', 'verge', 'grieve'],
  ['aid', 'maid', 'media', 'maiden'],
  ['sat', 'star', 'stare', 'arrest'],
  ['ace', 'race', 'crate', 'racket'],
  ['tea', 'date', 'dated', 'traded'],
];